<app-barra-crud
  [state]="state"
  (salvando)="salvarComValidacao($event)"
  (voltando)="busca()"
  (inserindo)="novo()"
  (editando)="editar()"
  (excluindo)="excluir()"
  (cancelando)="cancelar()"
  [formValido]="f.valid"
  [exibirExcluir]="habilitarExclusao">
</app-barra-crud>
<div class="conteudo cadastro">
  <form role="form" #f="ngForm" novalidate>
    <nav class="topo-abas">
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a translate id="dados-principais-tab" href="#dados-principais" aria-controls="dados-principais"
          aria-selected="true" class="nav-item nav-link active" data-toggle="tab" role="tab">
          {{'acessos.usuarioFabrica.cadastro.dadosPrincipais.abaDadosPrincipais'}}
        </a>
        <a translate id="dados-contato-tab" href="#dados-contato" aria-controls="dados-contato" aria-selected="false"
          class="nav-item nav-link" data-toggle="tab" role="tab">
          {{'acessos.usuarioFabrica.cadastro.contato.abaContato'}}
        </a>
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div id="dados-principais" aria-labelledby="dados-principais-tab" class="tab-pane fade show active"
        role="tabpanel">
        <header translate class="titulo">{{'acessos.usuarioFabrica.cadastro.dadosPrincipais.abaDadosPrincipais'}}
        </header>
        <div class="container-fluid">
          <div class="row">
            <div class="col col-lg-12">
              <small translate class="text-info">{{'acessos.usuarioFabrica.cadastro.CampoObrigatorio'}}</small>
              <hr />
            </div>
          </div>
          <!-- <div class="row">
            <app-text-box [state]="state" class="col-lg-4"
              label="{{'acessos.usuarioFabrica.cadastro.dadosPrincipais.idUsuario' | translate}}" name="idUsuario"
              [(ngModel)]="model.id"
              placeholder="{{'acessos.usuarioFabrica.cadastro.dadosPrincipais.idUsuarioPlaceHolder' | translate}}"
              [ativo]="false">
            </app-text-box>
          </div> -->
          <div class="row">
            <app-text-box [state]="state" class="col-lg-4"
              label="{{'acessos.usuarioFabrica.cadastro.dadosPrincipais.nome' | translate}}" name="nome"
              [(ngModel)]="model.nome" obrigatorio="true" required
              placeholder="{{'acessos.usuarioFabrica.cadastro.dadosPrincipais.nomePlaceHolder' | translate}}">
            </app-text-box>
            <app-text-box mascara="000.000.000-00" [state]="state" class="col-lg-4"
              label="{{'acessos.usuarioFabrica.cadastro.dadosPrincipais.cpf' | translate}}" name="cpf"
              [(ngModel)]="model.cpf" obrigatorio="true" required
              placeholder="{{'acessos.usuarioFabrica.cadastro.dadosPrincipais.cpfPlaceHolder' | translate}}">
            </app-text-box>
          </div>
          <hr />
          <div class="row">
            <!-- <app-text-box mascara="000.000.000-00" [state]="state" class="col-lg-4"
              label="{{'acessos.usuarioFabrica.cadastro.dadosPrincipais.cpf' | translate}}" name="cpf"
              [(ngModel)]="model.cpf" obrigatorio="true" required
              placeholder="{{'acessos.usuarioFabrica.cadastro.dadosPrincipais.cpfPlaceHolder' | translate}}">
            </app-text-box> -->

            <app-dropdown-list-api [state]="state" class="col-lg-4"
              label="{{'acessos.usuarioFabrica.cadastro.dadosPrincipais.funcao' | translate}}" name="funcao"
              [(ngModel)]="model.funcao" obrigatorio="true" required filtro="funcao">
            </app-dropdown-list-api>

            <app-dropdown-list [state]="state" class="col-lg-4"
              label="{{'acessos.usuarioFabrica.cadastro.dadosPrincipais.status' | translate}}" name="ativo"
              [(ngModel)]="model.ativo" obrigatorio="true" required [itens]="itensAtivo">
            </app-dropdown-list>
          </div>
          <hr />
          <div class="row">
            <app-text-box-login [state]="state" class="col-lg-4"
              label="{{'acessos.usuarioFabrica.cadastro.dadosPrincipais.defineLogin' | translate}}" name="login"
              [(ngModel)]="model.login" obrigatorio="true" required
              placeholder="{{'acessos.usuarioFabrica.cadastro.dadosPrincipais.defineLoginPlaceHolder' | translate}}">
            </app-text-box-login>

            <app-dropdown-list-api [state]="state" class="col-lg-4"
              label="{{'acessos.usuarioFabrica.cadastro.dadosPrincipais.nivelAcesso' | translate}}" name="nivel_de_acesso"
              [(ngModel)]="model.nivel" obrigatorio="true" required filtro="nivel_acesso" (change)="filtroDealer($event)">
            </app-dropdown-list-api>

            <div class="col col-lg-12" *ngIf="filtros.dealer == 3">
              <div class="caixa">
                <div class="conteudo-caixa-sem-titulo sem-padding">
                  <div class="filtro-dash">
                    <div >
                      <div translate class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                        {{'relatorioVeiculos.veiculoEstoque.dealers'}}
                      </div>
                      <span class="btn btn-outline-info btn-sm" *ngFor="let dealer of dealersSelecionados"
                        style="margin: 6px 2px 0px 2px; text-transform: uppercase;" (click)="removerDealer(dealer)">
                        {{dealer.descricao}}
                        <i class="fa fa-times" aria-hidden="true" (click)="removerDealer(dealer)"></i>
                      </span>
                      <div class="botao">
                        <button class="btn btn-info btn-sm" (click)="showDialog()" [disabled]="state === 0">
                          <em class="fa fa-plus"></em>
                        </button>
                      </div>
                      <div class="clear"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>   

          </div>

          
          <hr />
          <div class="row" *ngIf="state != 1">
            <div class="form-group col-lg-6">
              <label translate
                class="control-label">{{'acessos.usuarioFabrica.cadastro.dadosPrincipais.solicitarRedefinicaoSenha'}}</label>
              <br />
              <button translate class="btn btn-primary" [disabled]="state != 0" (click)="solicitarRedefinicaoSenha()">
                <em class="fa fa-envelope"></em>
                {{'acessos.usuarioFabrica.cadastro.dadosPrincipais.enviarEmail'}}
              </button>
              <span class="help-block" *ngIf="state != 0">
                <small translate class="form-text" style="color: #ff0000">
                  {{'acessos.usuarioFabrica.cadastro.dadosPrincipais.naoPodeEnviarEmailUsuarioEdicao'}}
                </small>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div id="dados-contato" aria-labelledby="dados-contato-tab" class="tab-pane fade" role="tabpanel">
        <header translate class="titulo">{{'acessos.usuarioFabrica.cadastro.contato.abaContato'}}</header>
        <div class="container-fluid">
          <div class="row">
            <div class="form-group col-lg-12">
              <small translate
                class="form-text text-muted">{{'acessos.usuarioFabrica.cadastro.CampoObrigatorio'}}</small>
            </div>
          </div>
          <div class="row">
            <app-text-box [state]="state" class="col-lg-6"
              label="{{'acessos.usuarioFabrica.cadastro.contato.email' | translate}}" name="email"
              [(ngModel)]="model.email"
              placeholder="{{'acessos.usuarioFabrica.cadastro.contato.emailPlaceHolder' | translate}}" [ativo]="true">
            </app-text-box>
          </div>
          <div class="row">
            <app-text-box mascara="0{3}" [state]="state" class="col-lg-2"
              label="{{'acessos.usuarioFabrica.cadastro.contato.ddd' | translate}}" name="ddd"
              [(ngModel)]="model.ddd" obrigatorio="true" required
              placeholder="{{'acessos.usuarioFabrica.cadastro.contato.dddPlaceHolder' | translate}}">
            </app-text-box>

            <app-text-box mascara="0{4}-0{5}" [state]="state" class="col-lg-4"
              label="{{'acessos.usuarioFabrica.cadastro.contato.telefone' | translate}}" name="telefone"
              [(ngModel)]="model.telefone" obrigatorio="true" required
              placeholder="{{'acessos.usuarioFabrica.cadastro.contato.telefonePlaceHolder' | translate}}">
            </app-text-box>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<p-dialog [(visible)]="display" [modal]=true [style]="{width: '40rem'}">
  <ng-template pTemplate="header">
    <div>
      <h5 translate class="modal-title" [innerHTML]="modalTexto"></h5>
    </div>
  </ng-template>
  <ng-template pTemplate="body">
    <div class="d-inline-flex" *ngFor="let dealer of dealers">
      <button class="btn btn-primary btn-sm itemListaSelecao m-1" pTooltip="{{dealer.descricao}}" tooltipPosition="top"
        (click)="adicionarTipoCategoria(dealer)">{{dealer.descricao}}&nbsp;
        <i class="fa fa-plus"></i>
      </button>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button translate type="button" class="btn btn-secondary" (click)="hideDialog()">Fechar</button>
  </ng-template>
</p-dialog>